import {useEffect, useState} from 'react';
import {uploadService} from '../services/upload';
import {getExtFromName, getPreviewType} from '../utils/filePreview';

const cache = new Map<string, string>();

export function useObsThumbnail(
  obskey?: string,
  fileName?: string
) {
  const [url, setUrl] = useState('');

  const ext = getExtFromName(fileName || '');
  const previewType = getPreviewType(ext);

  const isImage = previewType === 'image';

  useEffect(() => {
    if (!obskey || !isImage) {
      setUrl('');
      return;
    }

    const cached = cache.get(obskey);

    if (cached) {
      setUrl(cached);
      return;
    }

    let canceled = false;

    uploadService.getTempDownloadUrl({obskey})
      .then((res: string) => {
        if (canceled) return;

        cache.set(obskey, res);
        setUrl(res);
      }).catch(() => {
      if (canceled) return;
      setUrl('');
    });

    return () => {
      canceled = true;
    };
  }, [obskey, isImage]);

  return url;
}